import themeInfo from '../../../themes/themes';
const theme = process.env.REACT_APP_THEME;

export default {
  to: themeInfo[theme].email,
  subject: 'Question for our team',
  body: "Are you running into an issue or have a question for our team? We're here to help.",
};
